/*global jQuery */
(function($) {

  'use strict';

  $(function() {
    
    
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      $('.nome_prodotto_intro').show().css('height', '30%');

      
    } else {
      $('.box_prodotti').hover(function() {
        $('.nome_prodotto_intro', this).stop().fadeIn();
      }, function() {
        $('.nome_prodotto_intro', this).stop().fadeOut();
      });

      $('.box_collezione').hover(function() {
        $('.nome_prodotto_intro', this).stop().fadeIn();
      }, function() {
        $('.nome_prodotto_intro', this).stop().fadeOut();
      });
    }

  });

}(jQuery));